import axios from "axios";

const GET_API_URL  = process.env.REACT_APP_CONFIGURL;
const SET_API_URL = process.env.REACT_APP_BASEURL;

/**
 * Backend: POST /api/configurations_email_flags (same router as /configurations, not under /settings).
 * REACT_APP_BASEURL is often .../api/settings — must not append flags there or you get 404.
 */
const getEmailFlagsUrl = () => {
  const cfg = (GET_API_URL || "").replace(/\/?$/, "");
  if (/\/configurations$/i.test(cfg)) {
    return `${cfg}_email_flags`;
  }
  const settingsBase = (SET_API_URL || "").replace(/\/?$/, "");
  if (/\/settings$/i.test(settingsBase)) {
    const apiRoot = settingsBase.replace(/\/settings$/i, "");
    return `${apiRoot}/configurations_email_flags`;
  }
  if (settingsBase) {
    return `${settingsBase}/configurations_email_flags`;
  }
  return "";
};

  
const headers =  { 
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}
  
const getConfiguration = () => {
  var payload = {
    functionName: "GetConfigurations",
    postData: {},
  }
  return axios.post(GET_API_URL, payload, {headers});
};

/** Only user_manual_file + rules_regulations_file — fast for modals */
const getConfigurationEmailFlags = () => {
  const url = getEmailFlagsUrl();
  if (!url) {
    return Promise.resolve({ data: { status: false, data: [] } });
  }
  return axios.post(url, { postData: {} }, { headers });
};

const setConfiguration = payload => {
  return axios.post(SET_API_URL, payload, {headers});
};

const ConfigurationService = {
  getConfiguration,
  getConfigurationEmailFlags,
  setConfiguration
};
  
export default ConfigurationService;

